import { Routes, Route, Navigate, Outlet, useLocation } from 'react-router-dom';
import Sidebar from './components/sidebar';
import Dashboard from './pages/dashboard';
import Suppliers from './pages/suppliers';
import Retailers from './pages/retailers';
import Sales from './pages/sales';
import Reports from './pages/reports';
import './App.css';
import ViewInventory from './pages/viewInventory';
import AddSupplier from './pages/addSuppliers';
import AddItem from './pages/inventory';
import AddRetailer from './pages/addRetailer';
import AddSales from './pages/addSales';
import Payments from './pages/payments';
import BankBalance from './pages/bankBalance';
import DayBook from './pages/dayBook';
import SupplierDetailsPage from './pages/supplierDetails';
import RetailerDetailsPage from './pages/retailerDetails';
import ReturnPage from './pages/salesReturn';
import ExpensesList from './pages/expenses';
import ExpenseForm from './pages/addExpenses';
import { useEffect, useState } from 'react';
import axios from 'axios';
import Login from './pages/login';
import { clearSession } from './auth';
import EditItem from './pages/editItem';
import EditSupplier from './pages/editSupplier';
import EditRetailer from './pages/editRetailer';
import CreditPage from './pages/credit';
import ViewCategories from './pages/CategoryList';
import EditSales from './pages/editSales';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const verifyToken = async () => {
      try {
        await axios.get('/users/verify');
        setIsAuthenticated(true);
      } catch (error) {
        console.error('Verification error:', error.response?.data);
        setIsAuthenticated(false);
        clearSession(); // Clear invalid session
      }
    };

    verifyToken();
  }, [location.pathname]);

  if (isAuthenticated === null) return <div>Loading...</div>;
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  
  return children ? children : <Outlet />;
};

// Main App Component
function App() {
  return (
    <div className="App">
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<Login />} />
        
        {/* Protected routes */}
        <Route element={<ProtectedRoute />}>
        <Route element={
          <div className="app-container">
            <Sidebar />
            <div className="main-content">
                <Outlet />
            </div>
          </div>
        }>
          <Route path="/" element={<Dashboard />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/inventory/add" element={<AddItem />} />
          <Route path="/inventory/edit/:id" element={<EditItem />} />
          <Route path="/inventory/viewInventory" element={<ViewInventory />} />
          <Route path="/categories" element={<ViewCategories />} />
          <Route path="/suppliers" element={<Suppliers />} />
          <Route path="/suppliers/add" element={<AddSupplier />} />
          <Route path="/suppliers/edit/:id" element={<EditSupplier />} />
          <Route path="/suppliers/details/:supplierId" element={<SupplierDetailsPage />} />
          <Route path="/retailers" element={<Retailers />} />
          <Route path="/retailers/edit/:id" element={<EditRetailer />} />
          <Route path="/retailers/details/:retailerId" element={<RetailerDetailsPage />} />
          <Route path="/retailers/add" element={<AddRetailer />} />
          <Route path="/sales" element={<Sales />} />
          <Route path="/sales/add" element={<AddSales />} />
          <Route path="/sales/edit/:invoiceId" element={<EditSales />} />
          <Route path="/sales/credit" element={<CreditPage />} />
          <Route path="/sales/return/:invoiceId" element={<ReturnPage />} />
          <Route path="/payments/add" element={<Payments />} />
          <Route path="/balance" element={<BankBalance />} />
          <Route path="/day-book" element={<DayBook />} />
          <Route path="/expenses" element={<ExpensesList />} />
          <Route path="/expenses/add" element={<ExpenseForm />} />
          <Route path="/expenses/edit/:id" element={<ExpenseForm />} />
          <Route path="/reports/*" element={<Reports />} />
        </Route>
        </Route>

        {/* Catch-all route */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

export default App;